<script setup lang="ts">
import BrownCap from "@/components/caps/BrownCap.vue";
import WhiteCap2 from "@/components/caps/WhiteCap2.vue";
import {onMounted} from "vue";

onMounted(() => {
    const ANIMATION_TYPES = {
        swing: "animate__tada",
    } as const;

    const handleIntersection = (target: Element, index: number) => {
        const type = target.getAttribute('data-animate-type');
        const animationClass = ANIMATION_TYPES[type as keyof typeof ANIMATION_TYPES];
        const delay = index * 0.2;

        target.classList.add("animate__animated", animationClass);
        (target as HTMLElement).style.setProperty('--animate-delay', `${delay}s`);
        target.classList.add('animate__delay');
    };

    const observer = new IntersectionObserver(
        (entries: IntersectionObserverEntry[]) => {
            entries
                .filter(entry => entry.isIntersecting)
                .forEach((entry, index) => handleIntersection(entry.target, index));
        },
        {
            threshold: 0.5,
        }
    );

    const elements = Array.from(document.querySelectorAll('#prizes [data-animate-type]'));
    elements.forEach((element, index) => {
        observer.observe(element);
    });
});
</script>

<template>
    <div id="prizes" class="text-center p-4">
        <div class="banner"></div>
        <h1 class="text-5xl text-kozel-white">Do wygrania</h1>
        <div class="py-4 flex justify-center">
            <img src="@/assets/images/prizes/playstation.webp" width="250px" alt="3 razy konsola PS5 Pro">
        </div>
        <div class="py-4 flex justify-center pl-12 relative">
            <WhiteCap2 data-animate-type="swing" class="absolute right-0 top-[-1rem] w-24"/>
            <img src="@/assets/images/prizes/oculus.webp" width="280px" alt="15 razy gogle VR Oculus Meta Quest 2">
        </div>
        <div class="py-4 flex justify-center pr-4 relative">
            <BrownCap data-animate-type="swing" class="absolute left-0 top-[-0.5rem] w-28"/>
            <img src="@/assets/images/prizes/voucher.webp" width="327px" alt="75 razy przelew 100 zł">
        </div>
    </div>
</template>

<style scoped>
#prizes {
    position: relative;
}

.banner {
    position: absolute;
    left: 0;
    top: -40px;
    z-index: -1;
    background-image: linear-gradient(transparent 80%, var(--color-kozel-sandy)), url("../../assets/images/backgrounds/bg-prizes.webp");
    background-size: cover;
    background-position: top;
    background-repeat: no-repeat;
    width: 100%;
    height: 1000px;
}

.animate__animated {
    animation-duration: 2s;
}
</style>